/**
 * Created By Vision CLI
 * Issues and merge requests are welcomed：https://git.code.oa.com/impage/vision
 *
 * API 参考：
 * http://vision.oa.com/docs/dev-container/#
 */
import 'intersection-observer';
import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
// ⚠️ 请勿修改，引入自动生成的 App
import App from './src/app';
import './assets/style/reset.css';
import './assets/style/common.css';
import AntiCrawler from '@tencent/pitu-anti-crawler';
import * as Sentry from '@sentry/react';
import { isMQQ } from '@tencent/h5-env-enhance';
import Aegis from '@tencent/aegis-web-sdk';
import VConsole from 'vconsole';

function isPrdEnv() {
  const PRD_HOSTNAMES = ['h5.tu.qq.com', 'h5.qzone.qq.com'];
  return PRD_HOSTNAMES.includes(window.location.host);
}

if (isPrdEnv()) {
  Sentry.init({ dsn: 'https://5a9cf0b75c554093b98f886cf02de095@report.url.cn/sentry/3032' });
}

new Aegis({
  id: 'CvFZizzJCaRRwOTflX', // 项目ID，即上报key
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  onError: false, // 关闭错误监控，错误统一上报至 sentry
});

const antiCrawler = new AntiCrawler({
  whitelist: [new RegExp('https://ai.tu.qq.com/.*')],
});
antiCrawler.install();

ReactDOM.render(<App />, document.getElementById('react-body'));

function pageLoadScript(filepath) {
  return new Promise(resolve => {
    const scriptDom = document.createElement('script');
    scriptDom.onload = function() {
      resolve(null);
    };
    scriptDom.type = 'text/javascript';
    scriptDom.src = filepath;
    document.body.appendChild(scriptDom);
  });
}

// 引入第三方依赖script文件
window?.addEventListener('load', () => {
  if (isMQQ()) {
    pageLoadScript('https://pub.idqqimg.com/qqmobile/qqapi.js?_bid=152');
  }
});

// debug模式开启vconsole
if (window?.location.href.includes('debug=1')) {
  const vConsole = new VConsole();
}

// 你也可以在此文件中进行一些初始化操作：
// 如引入公共样式、初始化上报等。
